export default __webpack_public_path__ + "static/media/vortex.51e55733.jpg";